module.exports = __webpack_public_path__ + "img/7 - Ralf Kistner.54187e36.png";